export const getAdHostData = async (url, token, adPlaceId, adType) => {
  try {
    const response = await fetch(
      `${url}/user-ad-host?adPlaceId=${adPlaceId}&adType=${adType}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(inputData),
      }
    );

    const resData = await response.json();

    console.log(resData, response);

    if (!response.ok) {
      throw new Error("something wrong");
    } 

    return resData;
      
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getVideoWithAdThumbnailUrls = async (url, token) => {
  try {
    const response = await fetch(
      `${url}/video-with-ad/thumbnail-urls`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(inputData),
      }
    );

    const resData = await response.json();

    console.log(resData, response);

    if (!response.ok) {
      throw new Error("something wrong");
    } 

    return resData;
      
  } catch (err) {
    console.log(err);
    throw err;
  }
};